function getEvents(pageId, flyingImagesId) {
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["small", "tiny"],
        target: {
          id: `${pageId}|${flyingImagesId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${flyingImagesId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1691401567053,
      },
      "e-2": {
        id: "e-2",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a-2", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["main", "medium"],
        target: {
          id: `${pageId}|${flyingImagesId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${flyingImagesId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-2-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1653889365075,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Layout 421 [Scroll] [Mobile]",
        continuousParameterGroups: [
          {
            id: "a-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-n",
                    actionTypeId: "TRANSFORM_SCALE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      xValue: 1,
                      yValue: 1,
                      locked: true,
                    },
                  },
                  {
                    id: "a-n-2",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-3",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-4",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      zValue: 4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-5",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-6",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      zValue: 0,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-7",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-8",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      zValue: -4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-9",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-10",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      zValue: 0,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                ],
              },
              {
                keyframe: 30,
                actionItems: [
                  {
                    id: "a-n-11",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-12",
                    actionTypeId: "TRANSFORM_SCALE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      xValue: 0.95,
                      yValue: 0.95,
                      locked: true,
                    },
                  },
                ],
              },
              {
                keyframe: 100,
                actionItems: [
                  {
                    id: "a-n-13",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      zValue: 4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-14",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      xValue: 90,
                      yValue: 80,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-15",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      zValue: 4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-16",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      xValue: -80,
                      yValue: -80,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-17",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      zValue: -4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-18",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      xValue: 120,
                      yValue: -40,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-19",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      zValue: 8,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-20",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      xValue: -120,
                      yValue: 60,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                ],
              },
            ],
          },
        ],
        createdOn: 1653889375681,
      },
      "a-2": {
        id: "a-2",
        title: "Layout 421 [Scroll] [Desktop]",
        continuousParameterGroups: [
          {
            id: "a-2-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-2-n",
                    actionTypeId: "TRANSFORM_SCALE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      xValue: 1,
                      yValue: 1,
                      locked: true,
                    },
                  },
                  {
                    id: "a-2-n-2",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-3",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-4",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      zValue: 8,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-5",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-6",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      zValue: 0,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-7",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-8",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      zValue: 4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-9",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-10",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      zValue: 0,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                ],
              },
              {
                keyframe: 30,
                actionItems: [
                  {
                    id: "a-2-n-11",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-12",
                    actionTypeId: "TRANSFORM_SCALE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "SIBLINGS",
                        selector: ".layout421_content",
                        selectorGuids: ["65e98b81-1c34-ed94-2e57-cc800d6fcdfc"],
                      },
                      xValue: 0.95,
                      yValue: 0.95,
                      locked: true,
                    },
                  },
                ],
              },
              {
                keyframe: 100,
                actionItems: [
                  {
                    id: "a-2-n-13",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      xValue: -140,
                      yValue: 60,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-14",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image5",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce01",
                        ],
                      },
                      zValue: 8,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-15",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      xValue: 140,
                      yValue: -40,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-16",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image4",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce02",
                        ],
                      },
                      zValue: -12,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-17",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      xValue: -50,
                      yValue: -90,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-18",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image3",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce04",
                        ],
                      },
                      zValue: 4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-19",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      zValue: -4,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-20",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout421_image-wrapper.is-image2",
                        selectorGuids: [
                          "65e98b81-1c34-ed94-2e57-cc800d6fcdf9",
                          "65e98b81-1c34-ed94-2e57-cc800d6fce00",
                        ],
                      },
                      xValue: 100,
                      yValue: 60,
                      xUnit: "%",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
